import Dashboard from './Dashboard';
import Hotel from './Hotel';
import Users from './Users';
import ChangeUser from './Users/changeuser';
import Events from './Events';
import CreateOutfit from './Outfit/createNew';
import CreateEvent from './Events/create';
import Transportation from './Transportation';
import Outfit from './Outfit';
import CreateTransit from './Transportation/create';
import EventDetail from './EventDetails';
import Module from './Module';
import EventParticipants from './EventParticipants';
import Profile from './profile';
import CreateUser from './Users/create';
import TransportList from './Transportation/transportList';
import UnauthenticatedUI from '../sharedcomponents/emptyStateContainer/unauthenticatedUI';
import Invitation from './Invitation';
import AgentProfile from './AgentProfile';
import Registration from './Registration';
import DraftRegistration from './DraftRegistration';
import BrandingColor from './BrandingColor';
import HotelBookingList from './Hotel/hotelBookingList';
import RegistrationList from './Registration/registrationList';
import DraftRegistrationList from './DraftRegistration/draftRegistrationList';
import Schedule from './Schedule';
import CreateHotel from './Hotel/create';
import UserActivities from './UserActivities';
import ParticipantModuleStatus from './ParticipantModuleStatus';
import Permissions from './Permissions';
import EventNotification from './Notification';
import Resource from './Resource';
import CreateResource from './Resource/create';
import myresource from './Resource/myresource';
import Ticket from './Ticket';
import CreateTicket from './Ticket/create';
import ticketSettings from './Ticket/ticketSettings';
import CreateDraftHotel from './DraftHotel/create';
import DraftHotelBookingList from './DraftHotel/hotelBookingList';
import DraftHotel from './DraftHotel';
import myticket from './Ticket/myticket';
// import StaffSchedule from './StaffSchedule';
import AppNotifications from './AppNotifications';
import SocialResponsibility from './SocialResponsibility';
import VipExperience from './VipExperience';
import CreateVipExperience from './VipExperience/create';
// import MediaCircuit from './MediaCircuit';
import AssignActivitiy from './MediaCircuit/AssignActivities';
import AllActivitiy from './MediaCircuit/AllActivities';
import CreateAllActivity from './MediaCircuit/AllActivities/create';
import MarkActivitiy from './MediaCircuit/MarkActivities';
import SatNightTransport from './SatNightTransport';
import SatNightTransportList from './SatNightTransport/satNightTransportList';
import CreateNightTransport from './SatNightTransport/create';
import CreateSatNightTransport from './SatNightTransport/satNightTransportCreate';
import SetTimings from './MediaCircuit/SetTimings';
import MediaCircuit from './MediaCircuit/mediaCircuit';
import SocialResponsibilityList from './SocialResponsibility/socialResponsibilityList';
import AllStarTicket from './AllStarTickets/index';
import AllStarEndUserTicket from './AllStarTickets/ticket/index';
import Settings from './Settings/settings';
import TransportSummary from './TransportSummary';
import AllStarRegistrationList from './AllStarRegistration/allStarRegistrationList';
import CreateAllStarRegistration from './AllStarRegistration/create';
import EventRegistrations from './Registration/index';
import Notes from './Notes';
import notesUser from './Notes/notesUser';
import notesDetails from './Notes/notesDetails';
import ChargeCard from './ChargeCard/index';
import DraftTransportation from './Transportation/DraftTransportation';
import DraftTransportList from './Transportation/DraftTransportation/transportList';
import CreateDraftTransit from './Transportation/DraftTransportation/create';

import DraftCombineTransportation from './Transportation/DraftCombineTransportation';
import DraftCombineTransportList from './Transportation/DraftCombineTransportation/transportList';
import CreateDraftCombineTransit from './Transportation/DraftCombineTransportation/create';
import AllStarHotel from './AllStarHotel';
import CreateAllStarHotel from './AllStarHotel/create';
import AllStarHotelBookingList from './AllStarHotel/hotelBookingList';
import Rosters from './Rosters';
import EventInstruction from './EventInstruction';
import EndUserEventInstructionList from './EventInstruction/endUserEventInstruction';
import EventHomeDetail from './EventHomeDetail';
import PrivateVehicle from './PrivateVehicle';
import CreatePrivateVehicle from './PrivateVehicle/create';
import CreateEndUserPrivateVehicle from './PrivateVehicle/privateVehicleCreate'
import keyContacts from './keyContacts';
import ActivityTracker from './ActivityTracker';
import CombineAssignActivitiy from './CombineActivityTracker/AssignActivities';
import CombineAllActivitiy from './CombineActivityTracker/AllActivities';
import CombineCreateAllActivity from './CombineActivityTracker/AllActivities/create';
import CombineMarkActivitiy from './CombineActivityTracker/MarkActivities';
import Credential from './Credential';
import credentialList from './Credential/credentialList';
import MyStatsReport from './MyStatsReport/index';
import combineFlightinfolist from './CombineFlightInfo/combineFlightinfolist';
import CombineflightInfo from './CombineFlightInfo';
import Createflightinfo from './CombineFlightInfo/create';
import LunchRoom from './LunchRoom';
import LunchRoomList from './LunchRoom/lunchRoomList';
import GreenRoomList from './GreenRoom/greenRoomList';
import GreenRoom from './GreenRoom';
import CreateGreenRoom from './GreenRoom/create';
import DraftFlightInfo from './DraftFlightInfo/index';
import DraftFlightInfoList from './DraftFlightInfo/draftFlightInfoList';
import DraftCreateFlightInfo from './DraftFlightInfo/create';
import ContactList from './ContactList';
import ParticipantModuleStatusNew from './ParticipantModuleStatusNew';


export default [
    Dashboard,
    Hotel,
    Users,
    ChangeUser,
    Events,
    CreateEvent,
    Transportation,
    CreateTransit,
    EventDetail,
    Module,
    EventParticipants,
    Profile,
    CreateUser,
    TransportList,
    Outfit,
    CreateOutfit,
    UnauthenticatedUI,
    Invitation,
    AgentProfile,
    Registration,
    EventRegistrations,
    DraftRegistration,
    // BrandingColor,
    HotelBookingList,
    RegistrationList,
    DraftRegistrationList,
    Schedule,
    CreateHotel,
    UserActivities,
    ParticipantModuleStatus,
    Permissions,
    EventNotification,
    Resource,
    CreateResource,
    myresource,
    Ticket,
    CreateTicket,
    ticketSettings,
    CreateDraftHotel,
    DraftHotelBookingList,
    DraftHotel,
    myticket,
    // StaffSchedule,
    AppNotifications,
    SocialResponsibility,
    VipExperience,
    CreateVipExperience,
    // MediaCircuit,
    AssignActivitiy,
    AllActivitiy,
    CreateAllActivity,
    MarkActivitiy,
    SatNightTransport,
    CreateNightTransport,
    SetTimings,
    SatNightTransportList,
    MediaCircuit,
    SocialResponsibilityList,
    CreateSatNightTransport,
    AllStarTicket,
    AllStarEndUserTicket,
    Settings,
    TransportSummary,
    AllStarRegistrationList,
    CreateAllStarRegistration,
    Notes,
    notesUser,
    notesDetails,
    ChargeCard,
    DraftTransportation,
    DraftTransportList,
    CreateDraftTransit,
    DraftCombineTransportation,
    DraftCombineTransportList,
    CreateDraftCombineTransit,
    AllStarHotel,
    CreateAllStarHotel,
    AllStarHotelBookingList,
    ActivityTracker,
    Rosters,
    EventInstruction,
    EndUserEventInstructionList,
    EventHomeDetail,
    PrivateVehicle,
    CreatePrivateVehicle,
    CreateEndUserPrivateVehicle,
    CombineAssignActivitiy,
    CombineAllActivitiy,
    CombineCreateAllActivity,
    CombineMarkActivitiy,
    Credential,
    credentialList,
    MyStatsReport,
    combineFlightinfolist,
    Createflightinfo,
    CombineflightInfo,
    LunchRoomList,
    LunchRoom,
    GreenRoomList,
    GreenRoom,
    CreateGreenRoom,
    DraftFlightInfo,
    DraftFlightInfoList,
    DraftCreateFlightInfo,
    ContactList,
    ParticipantModuleStatusNew
];
